var _circle, _path, _circle2, _path2, _circle3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle4, _path18, _circle5, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCoupleYellowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 90,
  height: 90,
  "data-name": "Layer 1",
  viewBox: "0 0 821 708.317"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 115.177,
  cy: 394.031,
  r: 110.853,
  fill: "#f0f0f0"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M115.481 394.03h.305l5.482 314.287h-11.573z"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 353.177,
  cy: 479.085,
  r: 80.853,
  fill: "#f0f0f0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M353.399 479.085h.223l3.998 229.232h-8.441z"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 251.349,
  cy: 183.976,
  r: 183.976,
  fill: "#ffbd01"
})), /*#__PURE__*/React.createElement("path", {
  d: "M576.69 156.936a183.99 183.99 0 0 1-306.558 194.715A183.992 183.992 0 1 0 576.69 156.936",
  opacity: 0.1,
  style: {
    isolation: "isolate"
  },
  transform: "translate(-189.5 -95.842)"
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M250.843 183.975h-.506l-9.098 521.602h19.207z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#cacaca",
  d: "M820 708.15H1a1 1 0 0 1 0-2h819a1 1 0 0 1 0 2"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "M676.812 698.025h-9.798l-4.661-37.79h14.46z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m679.31 707.522-31.59-.001v-.4a12.297 12.297 0 0 1 12.295-12.296h.001l19.295.001Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "M722.243 698.025h-9.797l-4.661-37.79h14.46z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m724.742 707.522-31.59-.001v-.4a12.297 12.297 0 0 1 12.295-12.296h.001l19.295.001Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "M557.784 698.025h9.798l1.818-37.994-11.617.204z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M555.285 694.826h19.295a12.297 12.297 0 0 1 12.296 12.295v.4l-31.59.001Z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "M518.178 698.025h9.797l1.942-37.994-11.741.204z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M515.679 694.826h19.295a12.297 12.297 0 0 1 12.296 12.295v.4l-31.59.001Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "M602.995 537.912a6.953 6.953 0 0 1 5.151-9.335l33.451-53.777 11.304 10.044-36.435 49.702a6.991 6.991 0 0 1-13.47 3.366M755.878 557.816a6.953 6.953 0 0 1-2.959-10.244l-14.372-61.679 15.095-.891 9.38 60.909a6.991 6.991 0 0 1-7.144 11.905"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "M613.616 535.259a7.767 7.767 0 0 0-9.388-7.33l-14.305-23.606-6.149 12.959 14.527 20.43a7.81 7.81 0 0 0 15.315-2.453M494.08 559.95a7.767 7.767 0 0 0-2.892-11.553l3.246-27.411-12.82 6.433-1.117 25.044a7.81 7.81 0 0 0 13.583 7.488"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m669.045 532.184-4.155 8.44-3.272 143.408 21.377 1.566 20.061-105.176 4.838 103.61 17.58.168 19.017-141.304zM563.53 532.184l6.937 4.11s5.638 3.588 3.742 28.548-4.161 124.963-4.161 124.963H557.75l-19.918-119.458-7.268 120.753-12.945-.647s-26.449-137.478-15.004-152.398Z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#e4e4e4",
  d: "m667.526 428.906 23.352-7.793 28.674.42 19.509 7.787 5.43 113.576s-42.689 25.573-79.6-2.272Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#e4e4e4",
  d: "M667.526 427.906s-9.213-1.08-14.348 14.211-18.715 35.978-18.715 35.978l14.854 13.929 29.71-41.203ZM731.814 431.465l7.247-2.145s16.413 2.188 17.067 19.845 3.759 45.292 3.759 45.292l-16.741 3.337Z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "M498.428 443.851s33.74-10.846 60.961-.734l-2.228 52.509 16.791 40.959s-53.382 20.707-71.172 3.305l5.188-41.028Z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "m550.319 449.284 7.07-6.167s4.716-.055 8.775 7.2 11.412 30.677 11.412 30.677l23.54 39.875-10.356 7.12-37.335-52.215ZM499.68 446.44l.481-3.29s-13.146.973-14.258 13.64-5.178 84.144-5.178 84.144l13.004 2.59 12.935-73.361Z"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 707.082,
  cy: 388.833,
  r: 21.818,
  fill: "#ffb6b6"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m545.254 424.874-39.44 7.766a3.12 3.12 0 0 1-3.663-2.457l-3.348-17a23.218 23.218 0 1 1 45.56-8.972l3.348 17a3.12 3.12 0 0 1-2.457 3.663"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 526.848,
  cy: 410.738,
  r: 17.023,
  fill: "#ffb6b6"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m550.088 404.85-24.117 4.748-.93-3.413-.554 3.706-3.714.731-1.841-6.766-1.1 7.345-7.185 1.415-.067-.34a18.387 18.387 0 0 1 14.472-21.569l3.4-.67a18.387 18.387 0 0 1 21.569 14.473Z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M530.014 431.171a3 3 0 0 1-.551.059l-18.273.362-5.748-29.186 19.44-3.828-.37.655c-5.159 9.129 2.38 20.798 7.332 26.942a3.07 3.07 0 0 1 .39 3.248 3.1 3.1 0 0 1-2.22 1.748M685.85 369.164c2.667-.822 5.55-.415 8.273.195l-.26.66c6.502-3.767 14.24-5.852 21.616-4.408s14.173 6.878 15.957 14.178a21.7 21.7 0 0 1 .118 8.872 31.13 31.13 0 0 1-14.339 20.982c-.935.566-2.376.97-2.928.027-.627-1.07.788-2.158 1.21-3.325.462-1.277-.378-2.693-1.47-3.501s-2.423-1.227-3.564-1.963a10.14 10.14 0 0 1-4.128-7.043 30 30 0 0 1 .255-8.377 43.5 43.5 0 0 1-13.665 2.627 10 10 0 0 1-4.843-.766c-1.959-.998-3.14-3.024-4.213-4.944l-1.347-2.411a10.23 10.23 0 0 1-1.71-4.828c.001-2.79 2.372-5.154 5.039-5.975"
})));
export default SvgCoupleYellowIcon;